import { render, staticRenderFns } from "./AccountActivation.vue?vue&type=template&id=648c4f3b&"
import script from "./AccountActivation.vue?vue&type=script&lang=ts&"
export * from "./AccountActivation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports